<template>
  <div class="home-widget col-sm-12 col-md-12 col-lg-4">
    <spinner-loader v-if="loading" :height="280" />
    <div class="widget-body" v-else>
      <p class="widget-title"><font-awesome-icon icon="chart-pie" /> Your last Visualizations:</p>
      <render-index-table :visualizations="$store.state.visualizations.items" :fields="fields"/>
    </div>
  </div>
</template>

<script>
  import SpinnerLoader from '../Spinner-loader.vue';
  import RenderIndexTable from '../../views/visualizations/RenderIndexTable';
  export default {
    components: {
      SpinnerLoader,
      RenderIndexTable
    },
    data() {
      return {
        loading: true,
        fields: ['title', 'actions']
      }
    },
    computed: {

    },
    beforeCreate() {
      this.$store.commit('visualizations/SET_PAGINATION_LIMIT', 5);
      this.$store.dispatch('visualizations/fetch').then(() => {
        this.loading = false;
        this.$store.commit('visualizations/SET_PAGINATION_LIMIT', 50);
      })
    },
        
  }
</script>
